export default __webpack_public_path__ + "static/media/_bitcoin-cash.7c35c61a.svg";